import { useAuthQuery } from '@/hooks/useAuthQuery'
import { useEffect, useMemo, type ReactNode } from 'react'
import { setSentryUser, clearSentryUser } from '@/lib/monitoring/helpers'
import AuthContext from './auth-context-instance'
import type { AuthContextType } from './auth-context-instance'

interface AuthProviderProps {
  children: ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const { data: userInfo, isPending } = useAuthQuery()

  useEffect(() => {
    if (userInfo) {
      setSentryUser(userInfo)
    } else if (!isPending) {
      clearSentryUser()
    }
  }, [userInfo, isPending])

  const value = useMemo<AuthContextType>(
    () => ({
      userInfo,
      loading: isPending,
      isAuthenticated: !!userInfo,
      isActive: userInfo?.isActive ?? false,
    }),
    [userInfo, isPending],
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthContext
export type { AuthContextType }
